
const textColoredMaker = (input, target) => {
    const regex = new RegExp(escapeRegExp(input), 'gi');
    return target.replace(regex, `<span class="bold">$&</span>`);
  };

  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  };

export default textColoredMaker
